import { parseAsArrayOf, parseAsString, useQueryStates } from 'nuqs';

export default function useExamDistributionListSearchParams() {
  const [{ examCenters }, setExamDistributionSearchParams] = useQueryStates({
    examCenters: parseAsArrayOf(parseAsString).withDefault([]),
  });

  const handleExamCenterChange = (examCenters: string[]) => {
    setExamDistributionSearchParams({ examCenters });
  };

  return [{ examCenters }, { handleExamCenterChange }] as const;
}
